module.exports = __webpack_public_path__ + "media/assets/icons/fund grey-0d29187381fe4f9277bf95ace517a3bb.svg";